import React, { Component } from "react";
import AudioTuner from "../../audioTuner";
import { connect } from "react-redux";
import "../../styles/tuner.css";
import TunerText from "./tunerText";
import { setWidgetStarted } from "../../store/actions";

class Tuner extends Component {
  state = {
    note: "C2",
    frequency: "65.41Hz",
    initialized: false,
  };

  audioTuner = new AudioTuner(this);

  componentDidMount() {
    this._isMounted = true;
    if (this.props.widgetStarted && !this.state.initialized) {
      this.audioTuner.start();
      this.setState({ initialized: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.widgetStarted !== this.props.widgetStarted ||
      prevProps.voiceDetect !== this.props.voiceDetect
    ) {
      if (this.props.widgetStarted && !this.state.initialized) {
        this.audioTuner.start();
        this.setState({ initialized: true });
      } else if (!this.props.widgetStarted || !this.props.voiceDetect) {
        this.audioTuner.tuner.stop(this.audioTuner);
      } else if (
        this.props.widgetStarted &&
        this.state.initialized &&
        this.audioTuner.stopped &&
        this.props.voiceDetect
      ) {
        this.audioTuner.start();
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.props.widgetStarted) {
      this.audioTuner.tuner.stop(this.audioTuner);
    }
  }

  render() {
    const { note, frequency } = this.state;

    return (
      <React.Fragment>
        <TunerText note={note} frequency={frequency} />
        <span
          className="close-tuner"
          onClick={() => {
            this.props.setWidgetStarted(false);
          }}
        >
          <svg
            className="w-6 h-6 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fillRule="evenodd"
              d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.707-3.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293Z"
              clipRule="evenodd"
            />
          </svg>
        </span>
        <svg
          width="2cm"
          height="2cm"
          viewBox="0 0 400 400"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
        >
          <path
            d="M 100 100 L 300 100 L 200 300 z"
            fill="#c5a73b"
            id="svgPath"
          />
        </svg>
        <div className="animate-tuner">
          <div
            className="point lgPoint"
            style={{ transform: "rotate(-45deg)" }}
          />
          <div className="point" style={{ transform: "rotate(-36deg)" }} />
          <div className="point" style={{ transform: "rotate(-27deg)" }} />
          <div className="point" style={{ transform: "rotate(-18deg)" }} />
          <div className="point" style={{ transform: "rotate(-9deg)" }} />
          <div
            className="point lgPoint"
            style={{ transform: "rotate(0deg)" }}
          />
          <div className="point" style={{ transform: "rotate(9deg)" }} />
          <div className="point" style={{ transform: "rotate(18deg)" }} />
          <div className="point" style={{ transform: "rotate(27deg)" }} />
          <div className="point" style={{ transform: "rotate(36deg)" }} />
          <div
            className="point lgPoint"
            style={{ transform: "rotate(45deg)" }}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    voiceDetect: state.voiceDetect,
    widgetStarted: state.widgetStarted,
  };
};

const mapDispatchToProps = {
  setWidgetStarted,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tuner);
